(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-access-gate"] && !Shopify.designMode) return;
  try {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Cart apps (Rebuy) post their own cart update alongside ours. On a visitor's
  // first cart write the two requests can create separate carts, so keep saving
  // until the code is on the cart the cookie points to, read twice in a row.
  async function saveAccessCode(form, code) {
    const { cartUrl, cartUpdateUrl, accessKey } = form.dataset;
    let confirmedToken = null;

    for (let attempt = 0; attempt < 8; attempt += 1) {
      const cart = await fetch(`${cartUrl}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } }).then(
        (response) => response.json()
      );

      if (cart.attributes[accessKey] === code) {
        if (cart.token === confirmedToken) return;
        confirmedToken = cart.token;
      } else {
        confirmedToken = null;
        const response = await fetch(`${cartUpdateUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [accessKey]: code } }),
        });
        if (!response.ok) throw new Error(response.statusText);
      }

      await wait(400);
    }

    throw new Error('Passcode was not saved to the cart');
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-access-gate]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = document.getElementById('ProductAccessGateError');
    button.disabled = true;

    saveAccessCode(form, form.elements.product_access_code.value)
      .then(() => window.location.reload())
      .catch(() => {
        error.textContent = form.dataset.requestError;
        button.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-products-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-products-picker')) {
    customElements.define(
      'variant-products-picker',
      class VariantProductsPicker extends HTMLElement {
        connectedCallback() {
          this.card = this.closest('.variant-products__card');
          this.variants = JSON.parse(this.querySelector('[data-card-variants]').textContent);
          this.current = this.variants.find((variant) => variant.id === Number(this.dataset.variantId));
          if (!this.card || !this.current) return;

          this.addEventListener('change', (event) => {
            if (event.target.type !== 'radio') return;
            this.select(Number(event.target.dataset.index), event.target.value);
          });
          this.updateOptions();
        }

        // Keeps the other options when that combination exists; otherwise moves
        // to the first variant with the chosen value, preferring one in stock.
        select(index, value) {
          const options = [...this.current.options];
          options[index] = value;
          const withValue = this.variants.filter((variant) => variant.options[index] === value);
          const variant = this.find(options) || withValue.find((item) => item.available) || withValue[0];
          if (!variant) return;

          this.current = variant;
          this.updateOptions();
          this.updateCard();
        }

        find(options) {
          return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
        }

        // Marks each value against the current selection with the product
        // page's classes: unavailable when the combination does not exist,
        // sold-out when it exists but cannot be bought.
        updateOptions() {
          this.querySelectorAll('input[type="radio"]').forEach((input) => {
            const index = Number(input.dataset.index);
            const options = [...this.current.options];
            options[index] = input.value;
            const match = this.find(options);

            input.checked = this.current.options[index] === input.value;
            input.parentElement.classList.toggle('unavailable', !match);
            input.parentElement.classList.toggle('sold-out', Boolean(match) && !match.available);
          });
        }

        updateCard() {
          const variant = this.current;
          const colourIndex = Number(this.dataset.colourIndex);
          const colour = variant.options[colourIndex];
          // Level and colour show in their buttons, so they only reach the accessible name.
          const details = variant.options.filter((_, index) => index !== colourIndex);
          if (colour) details.push(colour);
          const cardTitle = [this.dataset.productTitle, ...details].join(', ');

          this.card.querySelectorAll('[data-card-link]').forEach((link) => {
            const url = new URL(link.href);
            url.searchParams.set('variant', variant.id);
            link.setAttribute('href', url.pathname + url.search);
          });

          const title = this.card.querySelector('[data-card-title]');
          title.textContent = this.dataset.productTitle;
          if (details.length) {
            const hidden = document.createElement('span');
            hidden.className = 'visually-hidden';
            hidden.textContent = `, ${details.join(', ')}`;
            title.append(hidden);
          }
          this.card.querySelector('.variant-products__media').setAttribute('aria-label', cardTitle);
          const image = this.card.querySelector('img.variant-products__image');
          if (image && variant.image) {
            image.srcset = variant.image.srcset;
            image.src = variant.image.src;
            image.alt = variant.image.alt || '';
          }

          this.card.querySelector('[data-card-price]').textContent = variant.price;
          const compare = this.card.querySelector('[data-card-compare]');
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
          this.card.querySelector('[data-card-was]').textContent = variant.was || '';
          const save = this.card.querySelector('[data-card-save]');
          save.textContent = variant.save || '';
          save.hidden = !variant.save;

          const idInput = this.card.querySelector('[data-card-variant-id]');
          if (idInput) idInput.value = variant.id;
          this.card.querySelector('[data-card-button]')?.setAttribute('aria-label', `${this.dataset.buttonLabel}: ${cardTitle}`);
          this.card.querySelector('[data-card-buy]').hidden = !variant.available;
          this.card.querySelector('[data-card-sold-out]').hidden = variant.available;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
